export default "__VITE_ASSET__2894bc65__"